module.exports = __webpack_public_path__ + "static/media/Star.2f887ae7.svg";